import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=350dbc32&scoped=true&"
import script from "./ProjectInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=350dbc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350dbc32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350dbc32')) {
      api.createRecord('350dbc32', component.options)
    } else {
      api.reload('350dbc32', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=350dbc32&scoped=true&", function () {
      api.rerender('350dbc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProjectInfo.vue"
export default component.exports